<template>
  <component :is="current_component"></component>
</template>

<script>
import { mapGetters } from 'vuex';
import OrganizationConnectionSteps from './OrganizationConnectionSteps.vue';
import OrganizationConnectionActionPending from './OrganizationConnectionActionPending.vue';
export default {
    name: 'OrganizationConnection',
    components: {
      OrganizationConnectionSteps, OrganizationConnectionActionPending
    },
    data: () => ({
    }),

    mounted(){
      if( this.ORGANIZATION_DEBT_RESULTS_STATUS === 'CONNECT' ){
        this.$router.push({name: 'Social'});
      }
    },
    methods: {},
    watch: {
      ORGANIZATION_DEBT_RESULTS_STATUS: function(newVal){
        if( newVal === 'CONNECT' ){
          this.$router.push({name: 'Social'});
        }
      }
    },
    computed:{
      current_component(){
        if(this.ORGANIZATION_DEBT_RESULTS_STATUS === 'PENDING'){
          return 'OrganizationConnectionActionPending';
        }
        return 'OrganizationConnectionSteps';
      },
      ...mapGetters('workspace', ['ORGANIZATION_DEBT_RESULTS_STATUS']),
    },
}
</script>